import React from 'react';
import {
    Overlay,
    Modal,
    ContainerContent,
    TextTitle,
    TextDescription,
} from './styles';

import Button from 'components/Button';

const OtpValidationModal = ({
    confirmAction = () => { },
    currentOtp = null,
    ...props
}) => (
    <>
        <Overlay>
            <Modal {...props}>
                <ContainerContent>
                    <TextTitle>
                        Token já utilizado!
                    </TextTitle>
                    <TextDescription>
                        O token {!currentOtp ? '' : (<span>{currentOtp} </span>)} já foi usado e não pode ser reutilizado.<br />Insira um novo token para continuar.
                    </TextDescription>
                </ContainerContent>
                <Button
                    title="OK"
                    onClick={confirmAction}
                    style={{ fontSize: '16px' }}
                ></Button>
            </Modal>
        </Overlay>
    </>
);

export default OtpValidationModal;